export default __webpack_public_path__ + "static/media/superball_mob_dark.c972a045.png";